import {
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DispatcherClass;
function Dispatcher() {
  if (DispatcherClass === VOID) {
    class $ {}
    initMetadataForInterface($, 'Dispatcher', VOID, VOID, VOID, [1]);
    DispatcherClass = $;
  }
  return DispatcherClass;
}
var DeleteSecretCommandClass;
function DeleteSecretCommand() {
  if (DeleteSecretCommandClass === VOID) {
    class $ {
      constructor(partyId, secretId) {
        this.j2m_1 = partyId;
        this.k2m_1 = secretId;
      }
      toString() {
        return 'DeleteSecretCommand(partyId=' + this.j2m_1.toString() + ', secretId=' + this.k2m_1.toString() + ')';
      }
      hashCode() {
        var result = this.j2m_1.hashCode();
        result = imul(result, 31) + this.k2m_1.hashCode() | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof DeleteSecretCommand()))
          return false;
        if (!this.j2m_1.equals(other.j2m_1))
          return false;
        if (!this.k2m_1.equals(other.k2m_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'DeleteSecretCommand');
    DeleteSecretCommandClass = $;
  }
  return DeleteSecretCommandClass;
}
//region block: exports
export {
  Dispatcher as Dispatcher3r3trxa1ofgr6,
  DeleteSecretCommand as DeleteSecretCommand2maivg8rp13gw,
};
//endregion

//# sourceMappingURL=DeleteSecretCommand.mjs.map
